import { useMutation } from "@apollo/client";
import { FeedbackPageForm } from "@datagame/ui";

import { FeedbackPage } from "../../gql/graphql";
import { GAME_ADD_RATING } from "../../graphql/mutations/Game";
import { Transition } from "../shared/Transition";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";
import { CustomizedBackground } from "../CustomizedBackground";

export interface FeedbackScreenProps {
  config: FeedbackPage;
  gameId: string;
  onSubmit: () => void;
  theme: string;
}

export const FeedbackScreen = ({ config, gameId, onSubmit, theme }: FeedbackScreenProps) => {
  const [addRating] = useMutation(GAME_ADD_RATING);
  const { isPreviewMode } = useGlobalConfiguration();

  const handleAddRating = (selectedRating: number) => {
    if (isPreviewMode) {
      return onSubmit();
    }

    addRating({
      variables: {
        gameId,
        rating: selectedRating,
      },
    });

    onSubmit();
  };

  return (
    <Transition>
      <CustomizedBackground config={config}>
        <FeedbackPageForm config={config} theme={theme} onSubmit={handleAddRating} />
      </CustomizedBackground>
    </Transition>
  );
};
